import React, { Component } from 'react'
import { List, ListItem, makeSelectable } from 'material-ui/List'
import Arrow from 'material-ui/svg-icons/hardware/keyboard-arrow-right'
import Avatar from 'material-ui/Avatar'
import moment from 'moment'
import { FormattedMessage } from 'react-intl'
import { getToken } from '../../../lib/index'

let SelectableList = makeSelectable(List)

class Upcoming extends Component {
  handleConferenceChange = conferenceId => {
    const token = getToken()
    this.props.selectConference(conferenceId, token)
    this.props.fetchConferenceDetails(token, conferenceId, this.props.guest)
  }

  render () {
    const roomList =
      this.props.rooms.length >= 1 ? (
        this.props.rooms.map((val, index) => (
          <ListItem
            key={index}
            value={val.id}
            leftAvatar={
              <Avatar color="#FFFFFF" backgroundColor="#45CE90">
                {val.name.charAt(0).toUpperCase()}
              </Avatar>
            }
            onTouchTap={() => this.handleConferenceChange(val.id)}
            rightIcon={
              this.props.selectConferenceId === val.id ? <Arrow/> : <Arrow/>
            }
            primaryText={val.name}
            secondaryText={
              <div>
                {val.guests} <FormattedMessage id="seminar.guests"/> •{' '}
                {moment(val.created_at).format('DD MMM, YYYY')}
              </div>
            }
          />
        ))
      ) : (
        <h3 style={{textAlign: 'center'}}>
          <FormattedMessage id="seminars.emptyRoom"/>
        </h3>
      )

    return (
      <div>
        <SelectableList
          style={{paddingBottom: 0, height: '78vh', overflow: 'auto'}}
          selectedItemStyle={{backgroundColor: '#ecedef'}}
          value={this.props.selectConferenceId}
          defaultValue={1}>
          {roomList}
        </SelectableList>
      </div>
    )
  }
}

export default Upcoming



// WEBPACK FOOTER //
// ./src/components/Seminars/UpcomingSeminars/UpcomingSeminars.js